import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('workstationModule', ['isWorkMainChannel'])
  },
  methods: {
    ...mapActions('workstationModule', ['syncStationList', 'setCurrentWorkStation', 'toggleMainChannel'])
  }
}
